import React, { useEffect, useState } from 'react'
import { FaSearch } from 'react-icons/fa'

import PageLayout from 'components/layouts/PageLayout'
import SectionLayout from 'components/layouts/SectionLayout'
import SmallBanner from 'components/SmallBanner'
import Card from 'components/Card'
import BlogSkeleton from 'components/BlogSkeleton'
import { IoIosClose } from 'react-icons/io'
import { useDispatch } from 'react-redux'
import { setValue } from './storeBlogsSlice'

import { blogBannerContent } from './content/banner.js'
import { getWPPosts } from 'services/wp'

function Blog() {
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [blogs, setBlogs] = useState([]);
  const [searchBlog, setSearchBlog] = useState([]);

  const filterSearched = (e) => {
    e.preventDefault();
    setBlogs(searchBlog.filter((item) => {
      const searchTerm = search.trim().toLowerCase();
      const titleLower = item.title.rendered.trim().toLowerCase();
      const includes = titleLower.includes(searchTerm);
      return searchTerm === '' ? item : includes;
    }))
  }

  const cancelSearch = (e) => {
    e.preventDefault();
    setBlogs(searchBlog)
    setSearch('');
  }

  const blogContent = (
    <>
      <form className="join flex justify-center" onSubmit={filterSearched}>
        <input
          type='text'
          className="input input-bordered join-item rounded-l-full w-full max-w-60"
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button type='button' className={`btn join-item ${search.length === 0 && 'hidden'}`} onClick={cancelSearch}><IoIosClose style={{ fontSize: '30px' }} /></button>
        <button type='submit' className="btn join-item rounded-r-full"><FaSearch /></button>
      </form>

      <div className='flex flex-wrap justify-center lg:justify-evenly gap-10 py-12 px-4'>
        {
          loading ? <BlogSkeleton /> :

            blogs.length === 0 ? (<div className='text-slate-400'>Blog not found. Please try other text.</div>) :

              blogs.map(card => (
                // <Card id={card.id} image={card.featured_media} title={card.title.rendered} body={card.excerpt.rendered} key={card.id} />
                <Card cardContent={card} key={card.id} />
              ))
        }

      </div>
    </>
  )

  // API and Redux
  const dispatch = useDispatch()

  useEffect(() => {
    // Change Tab Title
    document.title = "Blog - Insurance Enterprise"

    const fetchBlogs = async () => {
      setLoading(true)
      try {
        const blogsData = await getWPPosts({ per_page: 100 })
        dispatch(setValue(blogsData))
        setBlogs(blogsData);
        setSearchBlog(blogsData)
        setLoading(false)
      } catch (error) {
        console.error(`Error: ${error}`)
      } finally {
        setLoading(false)
      }
    }

    fetchBlogs();

  }, [dispatch]);

  return (
    <>

      <SmallBanner content={blogBannerContent} />
      <PageLayout
        content={<SectionLayout content={blogContent} />}
      />

    </>
  )
}

export default Blog